import { API } from "../../../utils/api";

export const getStoreListWithMac = async () => {
  const res = await API.get(`store-mac-list`);
  return res.data.data;
};

export const getStoreById = async (id) => {
  const res = await API.get(`store-details/${id}`);
  return res.data.data;
};

export const assignMactoStore = async (payload) => {
  const res = await API.post(`assign-mac-id`, payload);
  return res.data;
};

export const unAssignMactoStore = async (payload) => {
  const res = await API.post(`un-assign-macId`, payload);
  return res.data;
};

export const getStoreMappedRecipe = async ({ storeId, isAllList, query }) => {
  if (isAllList) {
    const res = await API.get(`stores/${storeId}/assigned-recipes`);
    return res.data;
  } else {
    const res = await API.get(`stores/${storeId}/assigned-recipes`, query);
    return res.data;
  }
};

export const assignRecipeToStoreApi = async ({ storeId, data }) => {
  const res = await API.post(`stores/${storeId}/assign-recipes`, data);
  return res.data;
};

export const deleteRecipeFromStoreApi = async ({ storeId, recipeId, data }) => {
  const res = await API.delete(`recipes/${recipeId}/stores/${storeId}`, {
    data,
  });
  return res.data;
};
